// src/components/browse/browseUtils.js

export function slugifyCategory(value) {
    return (value || "Uncategorized")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
}

export function parseTags(tagsString) {
    return (tagsString || "")
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
}

/**
 * Supports:
 * - "Gardening"
 * - "Gardening, bug catching"
 * - "Gardening / Bug Catching"
 * - "Gardening & Bug Catching"
 */
export function parseCategories(categoryString, max = 2) {
    const raw = (categoryString || "").trim();
    if (!raw) return ["Uncategorized"];

    return raw
        .split(/,|\/|&|\+|\|/g) // common separators
        .map((c) => c.trim())
        .filter(Boolean)
        .slice(0, max);
}
